
function Svg({width,stroke,fill}) {
  return (  
    <svg version="1.1" id="Logo" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width={width} viewBox="0 0 712 164" enableBackground="new 0 0 712 164" xmlSpace="preserve">
      <path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4.000000"
	d="
M710.500000,3.500000 
	C638.166687,3.500000 565.833313,3.500000 493.500000,3.500000 
"/>
      <path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4.000000"
	d="
M710.500000,25.500000 
	C638.166687,25.500000 565.833313,25.500000 493.500000,25.500000 
"/>
      <path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4.000000"
	d="
M710.500000,36.500000 
	C638.166687,36.500000 565.833313,36.500000 493.500000,36.500000 
"/>
      <path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4.000000"
	d="
M710.500000,14.500000 
	C638.166687,14.500000 565.833313,14.500000 493.500000,14.500000 
"/>
      <path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4.000000"
	d="
M710.500000,47.500000 
	C638.166687,47.500000 565.833313,47.500000 493.500000,47.500000 
"/>
      <path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4.000000"
	d="
M710.500000,58.500000 
	C638.166687,58.500000 565.833313,58.500000 493.500000,58.500000 
"/>
      <path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8.000000"
	d="
M52.500000,82.500000 
	C44.502033,82.764275 36.477909,81.903961 28.500790,83.005714 
	C17.829760,84.479530 8.055917,94.392227 5.847657,105.469627 
	C1.813939,125.704178 18.461540,140.949966 35.500889,139.510513 
	C39.831192,139.144684 44.278687,140.289581 48.750000,138.394836 
	C48.750000,129.833328 48.750000,121.166664 48.750000,112.459106 
	C42.585941,110.619759 36.498177,111.866135 30.500000,111.500000 
"/>
      <path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4.000000"
	d="
M475.500000,58.500000 
	C422.833344,58.500000 370.166656,58.500000 317.500000,58.500000 
"/>
      <path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8.000000"
	d="
M448.500000,115.500000 
	C443.166656,115.500000 437.832123,115.427803 432.500275,115.516869 
	C424.445435,115.651421 420.000000,119.967606 420.000000,127.500000 
	C420.000000,134.471970 425.044617,139.376007 432.500275,139.481506 
	C438.832336,139.571121 445.166901,139.469421 451.499847,139.519745 
	C453.262939,139.533752 454.929596,139.314651 457.121887,137.755463 
	C456.435242,127.165169 458.233246,115.771576 455.929199,104.514488 
	C454.804901,99.021294 449.280975,93.531487 441.499969,93.504745 
	C434.833405,93.481834 428.166656,93.500000 421.500000,93.500000 
"/>
      <path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8.000000"
	d="
M214.500000,115.500000 
	C209.166672,115.500000 203.832123,115.427795 198.500275,115.516869 
	C190.445450,115.651421 186.000000,119.967606 186.000000,127.500000 
	C186.000000,134.471970 191.044601,139.376022 198.500259,139.481522 
	C204.832321,139.571121 211.166916,139.469421 217.499847,139.519745 
	C219.262924,139.533752 220.929596,139.314651 223.121887,137.755463 
	C222.435226,127.165169 224.233246,115.771584 221.929214,104.514488 
	C220.804901,99.021347 215.281036,93.531487 207.499985,93.504745 
	C200.833389,93.481827 194.166672,93.500000 187.500000,93.500000 
"/>
      <path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="9.000000"
	d="
M512.500000,93.500000 
	C505.500519,93.688217 498.344910,92.477364 491.530975,94.127876 
	C480.499207,96.800072 472.872437,105.577522 473.888092,119.008461 
	C474.589996,128.290436 481.470337,136.673218 492.011993,138.944321 
	C498.089966,140.253754 504.334076,139.407837 510.500305,139.440674 
	C513.156433,139.454803 514.157166,137.648636 514.024109,134.998795 
	C513.338135,121.342072 514.505249,107.683250 513.383972,93.968605 
	C512.929810,88.413574 513.700928,82.334877 513.974304,76.498795 
	C514.052429,74.832283 514.301270,73.103203 513.500000,71.500000 
"/>
      <path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4.000000"
	d="
M290.500000,57.500000 
	C247.833328,57.500000 205.166672,57.500000 162.500000,57.500000 
"/>
      <path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5.000000"
	d="
M297.500000,47.000000 
	C304.560730,44.307491 310.431366,40.444172 313.561981,33.026161 
	C318.171844,22.103121 310.034149,8.892240 299.991943,6.534323 
	C288.512299,3.838886 278.405273,8.841733 275.118195,21.031874 
	C271.657318,33.866489 279.945770,44.606148 293.497101,46.027679 
	C294.685638,46.152359 295.833344,46.666668 297.000000,47.000004 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="9.000000"
	d="
M68.250000,92.500000 
	C68.231178,103.839264 67.028763,115.198318 68.984871,126.502617 
	C70.230980,133.703857 77.940735,140.874405 87.000748,140.519012 
	C95.581863,140.182388 102.260101,134.671753 103.972893,125.994652 
	C106.164665,114.890999 104.724953,103.671700 104.750000,92.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="9.000000"
	d="
M353.250031,140.500000 
	C353.166687,138.000000 353.017853,135.500168 353.011414,132.999969 
	C352.984375,122.500038 352.646667,111.984329 353.111359,101.504936 
	C353.485748,93.062325 347.153809,82.950539 335.488586,81.598389 
	C325.122467,80.396805 316.023560,87.139084 313.881287,96.974144 
	C313.291626,99.681252 312.994629,102.297722 313.008911,104.999954 
	C313.071564,116.833397 313.166687,128.666672 313.250031,140.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8.000000"
	d="
M575.500000,104.750000 
	C572.979004,105.875198 573.193420,103.152534 573.130493,102.487640 
	C572.753296,98.503746 570.207825,96.256462 566.973938,95.071121 
	C555.798462,90.974892 538.257751,93.283112 533.183716,108.063065 
	C527.811157,123.712509 537.156250,138.441681 554.502808,139.451950 
	C559.818054,139.761520 565.166687,139.500000 570.500000,139.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5.000000"
	d="
M377.500000,28.500000 
	C373.129395,27.697380 368.758453,27.399761 364.506836,29.017965 
	C361.002899,30.351608 358.314789,34.864082 359.000000,38.000000 
	C359.854828,41.911919 363.523468,44.966953 367.500061,44.991753 
	C372.838379,45.025047 378.177032,45.000000 384.000000,45.000000 
	C384.000000,36.840576 384.213104,29.161903 383.911713,21.503473 
	C383.756866,17.567736 379.215424,14.143795 375.000000,14.000334 
	C370.166565,13.835842 365.307007,14.429849 360.500000,13.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5.000000"
	d="
M100.500000,28.500000 
	C96.129387,27.697380 91.758446,27.399778 87.506844,29.017979 
	C84.002892,30.351618 81.314751,34.864086 82.000008,38.000000 
	C82.854828,41.911922 86.523460,44.966953 90.500053,44.991753 
	C95.838364,45.025047 101.177032,45.000000 107.000000,45.000000 
	C107.000000,36.840576 107.213097,29.161903 106.911720,21.503473 
	C106.756851,17.567745 102.215431,14.143798 97.999992,14.000335 
	C93.166580,13.835840 88.307014,14.429849 83.500000,13.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4.000000"
	d="
M143.500000,58.500000 
	C111.166664,58.500000 78.833336,58.500000 46.500000,58.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5.000000"
	d="
M154.000000,45.000000 
	C157.666672,45.000000 161.357422,45.270134 164.995163,44.945763 
	C173.501297,44.187298 179.798355,38.943401 179.798355,29.500000 
	C179.798355,20.056608 173.501953,14.803722 164.995026,14.056602 
	C161.185165,13.722001 157.321503,14.000000 153.000000,14.000000 
	C153.000000,29.329588 153.000000,44.164795 153.000000,59.000000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8.000000"
	d="
M408.500000,93.500000 
	C403.833344,93.500000 399.165253,93.426079 394.500275,93.514145 
	C381.586853,93.757935 374.460999,101.061165 371.550354,109.517334 
	C368.368561,118.761192 372.458984,130.350601 381.063568,135.901474 
	C384.835724,138.334946 389.331726,139.545639 394.000061,139.508545 
	C398.833099,139.470139 403.666656,139.500000 408.500000,139.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5.000000"
	d="
M196.500000,30.000000 
	C200.333328,30.000000 204.166946,29.972166 207.999908,30.009033 
	C210.929794,30.037212 213.502869,29.211624 215.491577,26.992445 
	C217.274750,25.002588 218.922943,22.964651 217.512131,19.994238 
	C215.972443,16.752445 214.240753,14.020639 210.000748,13.952971 
	C203.646729,13.851563 197.594894,13.785216 192.926361,19.439199 
	C188.626022,24.647285 187.871841,30.270016 190.632050,35.935669 
	C193.294754,41.401226 197.695633,45.158752 204.500900,45.065647 
	C208.155579,45.015644 211.878311,44.343979 215.500000,45.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="9.000000"
	d="
M273.500000,115.500000 
	C273.333313,113.166664 273.042603,110.834427 273.022034,108.499809 
	C272.943359,99.583015 267.007233,93.475952 258.000488,93.556129 
	C253.166107,93.599167 248.226578,92.618752 242.750000,94.787796 
	C242.750000,109.830658 242.750000,125.165329 242.750000,140.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5.000000"
	d="
M141.500000,13.500000 
	C136.365372,12.339936 131.160553,13.056286 126.000420,13.082651 
	C121.940742,13.103395 117.692383,17.948019 118.000008,21.500000 
	C118.411148,26.247269 121.436798,28.930082 126.500069,28.994482 
	C128.999664,29.026274 131.511398,28.848007 133.997421,29.034435 
	C138.064545,29.339437 142.307617,33.948017 142.000000,37.500000 
	C141.588837,42.247269 138.559677,44.829933 133.500946,45.024658 
	C128.501221,45.217110 123.468056,44.375099 118.500000,45.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="9.000000"
	d="
M653.750000,140.500000 
	C653.768799,129.160736 655.217896,117.752663 652.925659,106.515160 
	C651.475098,99.403824 646.946655,95.038155 639.503052,93.978592 
	C634.154114,93.217194 628.709900,92.813507 623.557739,94.212563 
	C621.342529,94.814087 620.178711,93.509430 618.500000,93.506363 
	C610.666687,93.492020 602.833008,93.467674 595.000488,93.547684 
	C594.175232,93.556114 593.356689,94.225708 591.750000,94.935234 
	C591.750000,109.830658 591.750000,125.165329 591.750000,140.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5.000000"
	d="
M325.000000,14.000000 
	C325.000000,20.833334 324.955261,27.667040 325.012390,34.499897 
	C325.070984,41.503834 329.806702,46.000000 337.000000,46.000000 
	C344.193298,46.000000 348.929016,41.503822 348.987610,34.499897 
	C349.044739,27.667040 349.000000,20.833334 349.000000,14.000000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5.000000"
	d="
M72.000000,7.000000 
	C72.000000,16.000000 72.017189,25.000044 71.994644,33.999985 
	C71.976089,41.409969 67.747635,46.000008 61.000000,46.000000 
	C54.253338,45.999992 49.989513,41.397560 50.037910,34.000248 
	C50.047661,32.510242 49.384434,30.894567 50.500000,29.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5.000000"
	d="
M249.500000,27.500000 
	C250.708527,18.565552 246.818924,13.951241 238.000244,14.028200 
	C235.167572,14.052919 232.286194,13.531845 229.000000,14.666662 
	C229.000000,24.661203 229.000000,34.830601 229.000000,45.000000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5.000000"
	d="
M417.500000,27.500000 
	C418.708527,18.565552 414.818909,13.951241 406.000244,14.028199 
	C403.167603,14.052918 400.286194,13.531845 397.000000,14.666662 
	C397.000000,24.661203 397.000000,34.830601 397.000000,45.000000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="9.000000"
	d="
M152.250000,77.500000 
	C152.166656,93.333336 151.589935,109.185226 152.184601,124.993057 
	C152.542679,134.511932 158.139771,139.658035 167.500061,139.503906 
	C169.166290,139.476456 170.833328,139.500000 172.500000,139.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="9.000000"
	d="
M124.750000,92.500000 
	C125.163437,108.500000 125.163437,124.500000 124.750000,140.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8.000000"
	d="
M666.750000,92.500000 
	C672.500000,105.833328 678.242554,119.169876 684.008545,132.496307 
	C684.803223,134.333038 685.813171,136.020187 688.000000,136.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="9.000000"
	d="
M622.000061,95.500000 
	C622.083374,110.500000 622.166687,125.500000 622.250061,140.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8.000000"
	d="
M712.500000,93.000000 
	C710.241577,93.013779 708.538574,92.750015 707.331116,95.936012 
	C703.099915,107.101044 699.184570,118.593414 693.214539,128.833588 
	C687.207764,139.136963 685.412537,151.048920 679.000000,161.000000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5.000000"
	d="
M432.500000,2.500000 
	C431.358246,13.818994 432.018433,25.171778 432.129089,36.498737 
	C432.182251,41.942303 436.365295,44.966503 442.000000,44.998867 
	C443.333313,45.006527 444.666656,45.000000 446.000000,45.000000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8.000000"
	d="
M574.000000,105.500000 
	C571.068665,114.242981 567.888367,116.499992 558.500000,116.500000 
	C553.833313,116.500000 549.166687,116.500000 544.500000,116.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8.000000"
	d="
M351.500000,113.500000 
	C341.833344,113.500000 332.166656,113.500000 322.500000,113.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5.000000"
	d="
M475.500000,15.500000 
	C473.680817,20.516844 469.390778,23.750261 466.447144,27.963057 
	C462.765137,33.232533 457.810699,37.577713 455.009796,43.504627 
	C454.456421,44.675598 453.458832,44.480408 452.500000,44.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5.000000"
	d="
M477.000000,14.250000 
	C468.833344,14.166667 460.666656,14.083333 452.500000,14.000000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5.000000"
	d="
M455.500000,44.000000 
	C459.881165,45.937553 464.504517,44.607071 468.999695,45.003323 
	C471.496552,45.223415 474.057770,44.466980 476.500000,45.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8.000000"
	d="
M172.500000,93.500000 
	C161.833328,93.500000 151.166672,93.500000 140.500000,93.500000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5.000000"
	d="
M446.000000,14.000000 
	C439.000000,14.000000 432.000000,14.000000 425.000000,14.000000 
"/>
<path stroke={stroke} fill={fill} opacity="1.000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="5.000000"
	d="
M297.000000,47.500000 
	C299.598480,52.156464 304.084106,55.089886 307.500000,59.000000 
"/>
</svg>
    );
}

export default Svg;

